export default "@fragment\r\nfn main() -> @location(0) vec4<f32> {\r\n  return vec4(1.0, 0.0, 0.0, 1.0);\r\n}\r\n"